import React, { useContext, useEffect } from 'react';
import { ApiContext } from '@api/api';
import { isNullOrUndefined } from '@utils/utils';
import useForm from '@hooks/useForm/useForm';
import { OpeningHourDefinitionsInDTO } from '@api/ringil-api.v2';
import useTranslation from '@hooks/i18n/useTranslation.tsx';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar.tsx';
import LocationOpeningHoursEditor, { openingHoursValidationSchema } from '@components/RingilComponents/LocationOpeningHours/LocationOpeningHoursEditor.tsx';
import LocationSidebarHeader from '@components/RingilComponents/LocationSidebarHeader/LocationSidebarHeader.tsx';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  onCompleted: () => void;
  locationId?: string;
}

const EditOpeningHours: React.FC<ComponentProps> = ({ visible, onHide, onCompleted, locationId }) => {
  const { tr } = useTranslation();
  const { getLocationOpeningHours, updateLocatioOpeningHours } = useContext(ApiContext);

  const formik = useForm<OpeningHourDefinitionsInDTO>(openingHoursValidationSchema, null, values => save(values), false, false);

  useEffect(() => {
    if (visible && !isNullOrUndefined(locationId)) {
      formik.clear();
      getLocationOpeningHours(locationId, d => formik.setValues(d));
    }
  }, [visible]);

  const save = (values: OpeningHourDefinitionsInDTO) => {
    updateLocatioOpeningHours(locationId, values, () => {
      onCompleted();
    });
  };

  return (
    <RingilSidebar
      visible={visible}
      heading={tr('LocationOpeningHours.heading', 'Opening hours')}
      onBack={onHide}
      onContinue={() => formik.validateAndSend()}
      continueLabel={tr('generic.save', 'Save')}
      dataTestIdContinue={'location-openingHours-save'}
      dataTestIdBack={'location-openingHours-back'}>
      <div className={'flex flex-col gap-8'}>
        <LocationSidebarHeader locationId={locationId} />
        <LocationOpeningHoursEditor value={formik.values} onChange={v => formik.setValues(v)} validationErrors={formik.validationErrors} />
      </div>
    </RingilSidebar>
  );
};

export default EditOpeningHours;
